import _ from 'lodash';
import GridRow from './gridRow';
import Tasks from '../../controllers/tasks';
import InlineEditors from '../../controllers/inlineEditors';
import WebixContextMenu from '../webixContextMenu';
import MassSelect from '../../controllers/massSelect';
import routerHelper from '$$routerHelper';
import MassChangeSelectMenu from '../massChangeSelectMenu';

const ADD_MILESTONE_BUTTON_CLASS = 'js_add_milestone';

class GridRows {
  #instance;

  init(instance) {
    this.#instance = instance;
    GridRow.init(instance); // Adds custom gantt render
  }

  onTaskClick(taskId, event) {
    if (!this.#isExpandCollapseArea(event.target) && (this.#instance.config.isArchived || routerHelper.isHistoryRoute())) return;
    const task = this.#instance.getTask(taskId);
    const msSelectOptionsNode = event.target.closest('.mc-item-arrow');

    if (msSelectOptionsNode) {
      MassChangeSelectMenu.show({ taskId, anchorNode: msSelectOptionsNode });

      return;
    }

    if (this.#isExpandCollapseArea(event.target)) {
      InlineEditors.onClick(true);
      Tasks.toggleTask(taskId);

      return;
    }

    if (routerHelper.isTaskSettingsRoute()) {
      InlineEditors.disableEditing();
      this.#instance.callEvent('onOpenTaskSettings', [taskId]);
      InlineEditors.enableEditing();

      return true;
    }

    if (event.target.closest('.gantt_data_area') &&  task && task?.type !== this.#instance.config.types.button) {
      Tasks.selectAndShowTask(taskId);

      return;
    }

    const isCreateTaskButton = task?.type === this.#instance.config.types.button;

    if (this.#instance.ganttDataApi.isMassChangeEnabled() && !isCreateTaskButton) {
      taskId = Number(taskId);

      if (MassSelect.isTaskSelected(taskId)) {
        MassSelect.unselectTask(taskId);
      } else {
        MassSelect.selectTask(taskId);
      }

      return false;
    }

    if (isCreateTaskButton) {
      InlineEditors.newTaskType = event.target.classList.contains(ADD_MILESTONE_BUTTON_CLASS)
        ? this.#instance.config.types.milestone
        : this.#instance.config.types.task;

      return;
    }

    const columnOptionsNode = event.target.closest('.column-options-cog.icon-dots');

    if (columnOptionsNode) {
      WebixContextMenu.show({ taskId, anchorNode: columnOptionsNode, anchorPosition: null });
      InlineEditors.hide();

      return;
    }

    if (event.target.closest('.gantt_grid_fast_button_delete')) {
      InlineEditors.disableEditing();
      Tasks.delete(taskId);
      InlineEditors.enableEditing();
      userExtAnalytics.log('gantt_grid_fast_button_click', { type: 'delete' });
      userExtAnalytics.log('task_grid_action', { action: 'delete' });

      return false;
    }

    if (
      event.target.closest('.gantt_grid_fast_button_edit')
      || (event.target.closest('div[data-name="text"]') && !event.target.closest('div[data-name="text"] .text_value_content'))
    ) {
      const taskExist = this.#instance.isTaskExists(taskId);

      if (taskExist && task.type !== this.#instance.config.types.button && task.parent && task.parent !== 1) {
        userExtAnalytics.log('gantt_task_settings_open', {
          from: routerHelper.analyticsFromRoute(),
          route: `${routerHelper.analyticsRoute()}/FastButton`,
        });
        InlineEditors.disableEditing();
        this.#instance.callEvent('onOpenTaskSettings', [taskId]);
        InlineEditors.enableEditing();
        userExtAnalytics.log('gantt_grid_fast_button_click', { type: 'task settings' });
      }

      return true;
    }

    if (event.target.closest('.notification_cell_comments')) {
      const taskExist = this.#instance.isTaskExists(taskId);

      if (taskExist && task.type !== this.#instance.config.types.button && task.parent && task.parent !== 1) {
        userExtAnalytics.log('gantt_task_settings_open', {
          from: routerHelper.analyticsFromRoute(),
          route: `${routerHelper.analyticsRoute()}/ClickOnComment`,
        });
        InlineEditors.disableEditing();
        this.#instance.callEvent('onOpenTaskSettings', [taskId, 'selectComment']);
        InlineEditors.enableEditing();
        userExtAnalytics.log('gantt_grid_fast_button_click', {type: 'comments'});
        userExtAnalytics.log('task_grid_action', { action: 'comments_open' });
      }

      return true;
    }

    if (event.target.closest('.notification_cell_attachments')) {
      const taskExist = this.#instance.isTaskExists(taskId);

      if (taskExist && task.type !== this.#instance.config.types.button && task.parent && task.parent !== 1) {
        userExtAnalytics.log('gantt_task_settings_open', {
          from: routerHelper.analyticsFromRoute(),
          route: `${routerHelper.analyticsRoute()}/ClickOnAttachment`,
        });
        InlineEditors.disableEditing();
        this.#instance.callEvent('onOpenTaskSettings', [taskId, 'selectAttachments']);
        InlineEditors.enableEditing();
        userExtAnalytics.log('gantt_grid_fast_button_click', {type: 'attachments'});
        userExtAnalytics.log('task_grid_action', { action: 'attachments_open' });
      }

      return true;
    }

    return true;
  }

  onTaskDblClick(taskId, event) {
    if (this.#instance.ganttDataApi.isProjectArchived(this.#instance.config.gantt_id)) return;

    const task = this.#instance.isTaskExists(taskId) && this.#instance.getTask(taskId);

    if (task && task.type !== this.#instance.config.types.button && task.parent && task.parent !== 1) {
      this.#instance.callEvent('onOpenTaskSettings', [taskId]);

      userExtAnalytics.log('gantt_task_settings_open', {
        from: routerHelper.analyticsFromRoute(),
        route: `${routerHelper.analyticsRoute()}/DoubleClick Chart`,
      });
    } else {
      return false;
    }
  }

  #isExpandCollapseArea(node) {
    return node.classList.contains('gantt_tree_icon_item') || node.closest('gantt_tree_icon_item')
      || (node.nodeName === 'svg' && node.parentNode.classList.contains('gantt_tree_icon_item'))
      || (node.nodeName === 'use' && node.parentNode.nodeName === 'svg' && node.parentNode.parentNode.classList.contains('gantt_tree_icon_item'));
  }
}

export default new GridRows();
